module.exports = __webpack_public_path__ + "static/media/badge_supporting_2.99469643.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_supporting_2.png
// module id = 226
// module chunks = 0